import React, { useEffect } from "react";
import axios from 'axios';
import GetRequest from '../Services/APIRequest'
import { useState } from 'react';


const PaymentComponent = () => {

    useEffect(() => {
        const loadRazorpayScript = () => {
            if (!document.querySelector("#razorpay-script")) {
                const script = document.createElement("script");
                script.id = "razorpay-script";
                script.src = "https://checkout.razorpay.com/v1/checkout.js";
                script.async = true;
                document.body.appendChild(script);
            }
        };
        loadRazorpayScript();
    }, []);

    const { data, error, isLoaded } = GetRequest(`/Orders/CreateOrder`);


    const handlePayment = async () => {
        try {




            const options = {
                key: "rzp_test_49I3DqvoRxaKcP", // Razorpay key
                amount: data.amount,
                currency: data.currency,
                name: "Test Company",
                description: "Payment for policy #23456",
                order_id: data.id,
                handler: function (response) {
                    alert("Payment successful!");
                    console.log("Payment Response:", response);
                },
                prefill: {
                    name: "John Doe",
                    email: "john@example.com",
                    contact: "9999999999",
                },
                theme: {
                    color: "#F37254",
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (err) {
            alert("Payment initiation failed.");
            console.error(err);
        }
    };

    return (
        <div>
            <h1>Make a Payment</h1>
            <button onClick={handlePayment}>Pay ₹500</button>
        </div>
    );
};

export default PaymentComponent;
